package com.ijoin.payment

object StripeCheckoutOverlay {
    fun present(
        publishableKey: String,
        clientSecret: String,
        locale: String,
        onSuccess: () -> Unit,
        onError: (String) -> Unit,
    ) {
        StripeCheckoutOverlayImpl.present(publishableKey, clientSecret, locale, onSuccess, onError)
    }

    fun dispose() {
        StripeCheckoutOverlayImpl.dispose()
    }
}

expect object StripeCheckoutOverlayImpl {
    fun present(
        publishableKey: String,
        clientSecret: String,
        locale: String,
        onSuccess: () -> Unit,
        onError: (String) -> Unit,
    )

    fun dispose()
}
